import { Action } from '@ngrx/store';
import {
    IContractStructure
} from '../IContractStructure';
import { IEntityFilter } from '../IEntityFilter';
import { ICustomer } from '../ICustomer';
import { IContractType } from '../IContractType';
import { IGenericResponse } from '../../shared';

export enum ActionTypes {
    Reset = '[customerjob] Reset',
    LoadCustomerJobs = '[customerjob] Load Customer Jobs',
    SetCustomerJobs = '[customerjob] Set Customer Jobs',
    LoadEntityFilter = '[customerjob] Load Entity Filter',
    SetEntityFilter = '[customerjob] Set Entity Filter',
    UpdateContractStructure = '[customerjob] Update Contract Structure',
    UpdateContractStructureSuccess = '[customerjob] Update Contract Structure Success',
    LoadCustomers = '[customerjob] Load Customers',
    SetCustomers = '[customerjob] Set Customers',
    LoadContractTypes = '[customerjob] Load Contract Types',
    SetContractTypes = '[customerjob] Set Contract Types'
}

export class Reset implements Action {
    readonly type = ActionTypes.Reset;
}

export class LoadContractTypes implements Action {
    constructor() {}
    readonly type = ActionTypes.LoadContractTypes;
}

export class LoadCustomers implements Action {
    constructor() {}
    readonly type = ActionTypes.LoadCustomers;
}

export class LoadEntityFilter implements Action {
    constructor() {}
    readonly type = ActionTypes.LoadEntityFilter;
}

export class LoadCustomerJobs implements Action {
    constructor(
        public payload: Array<ICustomer>,
        public filterpayload: IEntityFilter
    ) {}
    readonly type = ActionTypes.LoadCustomerJobs;
}

export class SetCustomerJobs implements Action {
    constructor(public payload: Array<IContractStructure>) {}
    readonly type = ActionTypes.SetCustomerJobs;
}

export class SetEntityFilter implements Action {
    constructor(public payload: Array<IEntityFilter>) {}
    readonly type = ActionTypes.SetEntityFilter;
}

export class SetCustomers implements Action {
    constructor(public payload: Array<ICustomer>) {}
    readonly type = ActionTypes.SetCustomers;
}

export class SetContractTypes implements Action {
    constructor(public payload: Array<IContractType>) {}
    readonly type = ActionTypes.SetContractTypes;
}

// export class LoadUserEntryDates implements Action {
//   constructor() {
//   }
//   readonly type = ActionTypes.LoadUserEntryDates;
// }

// export class SetUserEntryDates implements Action {
//   constructor(public payload: Array<IUserEntryDate>) {
//   }
//   readonly type = ActionTypes.SetUserEntryDates;
// }

export class UpdateContractStructure implements Action {
    constructor(public payload: Array<IContractStructure>) {}
    readonly type = ActionTypes.UpdateContractStructure;
}

export class UpdateContractStructureSuccess implements Action {
    constructor(public payload: IGenericResponse<IContractStructure>) {}
    readonly type = ActionTypes.UpdateContractStructureSuccess;
}

export type ActionsUnion =
    | Reset
    | LoadCustomerJobs
    | SetCustomerJobs
    | LoadEntityFilter
    | SetEntityFilter
    | UpdateContractStructure
    | UpdateContractStructureSuccess
    | LoadCustomers
    | SetCustomers
    | LoadContractTypes
    | SetContractTypes;
